import React, { useEffect, useState } from 'react';
import { Select, Divider, Space, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ProductCollectionService from 'services/product_collection';
import ProductCollectionModal from 'components/product_collection';

const service = new ProductCollectionService();

const ProductCollectionPicker = ({ value = [], onChange, mode = 'multiple', placeholder = 'Chọn collections' }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try {
      var list = await service.list({});
      list = Array.isArray(list) ? list : [];
      setOptions(list.map((x) => ({ label: x.title, value: x.id })));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleCreatedCollection = async (collection) => {
    await loadData();

    const createdId = collection?.id || collection?._id || collection?.data?.id || collection?.data?._id;
    if (!createdId || !onChange) {
      return;
    }

    const isMultiple = mode === 'multiple' || mode === 'tags';
    if (!isMultiple) {
      onChange(createdId);
      return;
    }

    const currentValues = Array.isArray(value) ? value : value ? [value] : [];
    const nextValues = currentValues.includes(createdId) ? currentValues : [...currentValues, createdId];
    onChange(nextValues);
  };

  return (
    <>
      <Select
        mode={mode}
        value={value}
        onChange={onChange}
        options={options}
        loading={loading}
        showSearch
        optionFilterProp="label"
        placeholder={placeholder}
        allowClear
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <Space style={{ padding: '0 8px 4px' }}>
              <Button type="link" icon={<PlusOutlined />} onClick={() => setOpenCreateModal(true)}>
                Thêm mới collection
              </Button>
            </Space>
          </>
        )}
      />

      <ProductCollectionModal
        open={openCreateModal}
        id={null}
        onClose={() => setOpenCreateModal(false)}
        onChange={handleCreatedCollection}
      />
    </>
  );
};

export default ProductCollectionPicker;
